import { Colors } from '../../../types/colors'

const colors: Colors = {
  primary: {
    100: '#CDE6E1',
    200: '#CDE6E1',
    500: '#165B60',
    700: '#165B60',
    800: '#165B60',
  },
  gray: {
    400: '#D3E2DF',
    600: '#577570', // TODO: Remove 600 since is now same as 700
    700: '#577570',
    900: '#063C3C',
  },
  // TODO: Use neutral instead of gray
  neutral: {
    400: '#D3E2DF',
    700: '#577570',
    900: '#063C3C',
  },
  info: {
    100: '#E4E2FF',
  },
  success: {
    100: '#CDE6E1',
    500: '#165B60',
  },
  error: {
    100: '#FCFOEE',
    500: '#F54A0D',
  },
  warning: {
    100: '#FDF4EB',
    500: '#FF704A',
  },
  bg: '#F5F8F7',
  states: {
    error: '#E14E2E',
    warning: '#FF704A',
    confirmation: '#5FDC91',
    disabled: '#D9DADB',
  },
}

export default colors
